export default "__VITE_ASSET__Cce7Q6L8__"